// extracted by mini-css-extract-plugin
module.exports = {"input":"Accordion-module--input--1PaSn","content":"Accordion-module--content--3ELNq","icon":"Accordion-module--icon--1Osan"};